module.exports = __webpack_public_path__ + "img/card.b1f0b1f1.png";